import React from "react";
import { Result, Button, Typography } from "antd";
import { LockOutlined, HomeOutlined, SettingOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const { Paragraph, Text } = Typography;

interface PermissionDeniedProps {
  title?: string;
  subTitle?: string;
  description?: string;
  action?: string;
  module?: string;
  showBackButton?: boolean;
  showContactAdmin?: boolean;
  customActions?: React.ReactNode;
}

const PermissionDenied: React.FC<PermissionDeniedProps> = ({
  title = "Accès Refusé",
  subTitle = "Vous n'avez pas les permissions nécessaires",
  description,
  action = "accéder à cette fonctionnalité",
  module = "E-commerce",
  showBackButton = true,
  showContactAdmin = true,
  customActions,
}) => {
  const defaultDescription = `Vous n'avez pas la permission de ${action} du module ${module}. Contactez votre administrateur système pour obtenir les autorisations appropriées.`;

  return (
    <div
      style={{
        padding: "50px 20px",
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Result
        status="403"
        icon={<LockOutlined style={{ color: "#ff4d4f", fontSize: "72px" }} />}
        title={
          <Text
            style={{ fontSize: "24px", fontWeight: "bold", color: "#262626" }}
          >
            {title}
          </Text>
        }
        subTitle={
          <Text style={{ fontSize: "16px", color: "#595959" }}>{subTitle}</Text>
        }
        extra={
          <div style={{ textAlign: "center" }}>
            <Paragraph
              style={{
                marginBottom: "24px",
                fontSize: "14px",
                color: "#8c8c8c",
                maxWidth: "500px",
              }}
            >
              {description || defaultDescription}
            </Paragraph>

            {showContactAdmin && (
              <div
                style={{
                  background: "#f6ffed",
                  border: "1px solid #b7eb8f",
                  borderRadius: "6px",
                  padding: "12px",
                  marginBottom: "24px",
                  maxWidth: "500px",
                  margin: "0 auto 24px auto",
                }}
              >
                <Text style={{ fontSize: "13px", color: "#389e0d" }}>
                  💡 <strong>Conseil :</strong> Demandez à votre administrateur
                  d'ajouter les permissions e-commerce à votre profil
                  utilisateur.
                </Text>
              </div>
            )}

            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {showBackButton && (
                <Link to="/accueil">
                  <Button type="primary" icon={<HomeOutlined />} size="large">
                    Retour à l'accueil
                  </Button>
                </Link>
              )}

              {showContactAdmin && (
                <Link to="/gestion-roles-permissions">
                  <Button icon={<SettingOutlined />} size="large">
                    Gestion des permissions
                  </Button>
                </Link>
              )}

              {customActions}
            </div>
          </div>
        }
        style={{
          background: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          maxWidth: "600px",
          width: "100%",
        }}
      />
    </div>
  );
};

export default PermissionDenied;
